import { useState, useEffect, useRef, useReducer, Reducer, useCallback } from 'react'
import axios, { Canceler } from 'axios'

import { useAPI } from '../api'

export const useUsers = (onForbidden?: Function, onError?: Function) => {
  const cancelRef = useRef<Canceler>()
  const { fetchData, updateData } = useAPI({ cancelRef, onError, onForbidden })

  const fetchUsers = () => {
    return fetchData(`/user`)
      .then((resp) => {
        return resp.data
      })
      .catch((error: any) => {
        return Promise.reject(error)
      })
  }

  return {
    fetchUsers,
  }
}

export const useAccounts = (onForbidden?: Function, onError?: Function) => {
  const cancelRef = useRef<Canceler>()
  const { fetchData } = useAPI({ cancelRef, onError, onForbidden })

  const fetchAccounts = () => {
    return fetchData(`/accounts`)
      .then((resp) => {
        return resp.data
      })
      .catch((error: any) => {
        return Promise.reject(error)
      })
  }

  return {
    fetchAccounts,
  }
}
